import { useQuery } from '@tanstack/react-query';
import { fetchShipmentTerms } from '../../data-provider/select-options';

export const useGetShipmentTerms = () => {
  return useQuery({
    queryKey: ['shipment-terms'],
    queryFn: () => fetchShipmentTerms(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
